var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4077 8.58594H23.3308C23.4688 8.58594 23.5808 8.69787 23.5808 8.83594V32.2206C23.5808 32.3586 23.4688 32.4706 23.3308 32.4706H18.4077C18.2696 32.4706 18.1577 32.3586 18.1577 32.2206V8.83594C18.1577 8.69787 18.2696 8.58594 18.4077 8.58594Z",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6401 14.3555H32.5632C32.7013 14.3555 32.8132 14.4674 32.8132 14.6055V32.2209C32.8132 32.3589 32.7013 32.4709 32.5632 32.4709H27.6401C27.5021 32.4709 27.3901 32.3589 27.3901 32.2209V14.6055C27.3901 14.4674 27.5021 14.3555 27.6401 14.3555Z",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17969 20.125H14.1028C14.2408 20.125 14.3528 20.2369 14.3528 20.375V32.2212C14.3528 32.3592 14.2408 32.4712 14.1028 32.4712H9.17969C9.04162 32.4712 8.92969 32.3592 8.92969 32.2212V20.375C8.92969 20.2369 9.04162 20.125 9.17969 20.125Z",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsage);
export default __webpack_public_path__ + "static/media/usage.14e0a2f23b64f856286ba8cc91534add.svg";
export { ForwardRef as ReactComponent };